import React from 'react';

const PeopleBold: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    height="20"
    fill="none"
    viewBox="0 0 20 20"
    width="20"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d={`M11.8818 11.5049C12.9528 11.5581 13.9687 12.0077 14.7305
      12.7695C15.543 13.5821 15.9999 14.6839 16 15.833V17.5C16 18.0523
      15.5523 18.5 15 18.5C14.4477 18.5 14 18.0523 14 17.5V15.833C13.9999
      15.2143 13.7539 14.6211 13.3164 14.1836C12.9336 13.8008 12.4315
      13.5648 11.8975 13.5117L11.667 13.5H8.33301C7.71429 13.5001 7.1211
      13.7461 6.68359 14.1836C6.24609 14.6211 6.00009 15.2143 6 15.833V17.5C6
      18.0523 5.55228 18.5 5 18.5C4.44772 18.5 4 18.0523 4 17.5V15.833C4.00009
      14.6839 4.45695 13.5821 5.26953 12.7695C6.08211 11.957 7.18385 11.5001
      8.33301 11.5H11.667L11.8818 11.5049ZM10.2148 1.50488C11.2859 1.558
      12.3026 2.00765 13.0645 2.76953C13.8768 3.58208 14.3339 4.68401 14.334
      5.83301L14.3281 6.04785C14.2751 7.11894 13.8263 8.13553 13.0645
      8.89746C12.3026 9.65933 11.2859 10.108 10.2148 10.1611L10 10.167C8.851
      10.1669 7.74907 9.70984 6.93652 8.89746C6.17457 8.13551 5.72492 7.11902
      5.67188 6.04785L5.66699 5.83301C5.66708 4.68385 6.12394 3.58211 6.93652
      2.76953C7.74909 1.95705 8.85092 1.50009 10 1.5L10.2148 1.50488ZM10
      3.5C9.38136 3.50009 8.78808 3.74619 8.35059 4.18359C7.91308 4.6211 7.66708
      5.21429 7.66699 5.83301L7.67871 6.06348C7.73167 6.59778 7.9676 7.10041
      8.35059 7.4834C8.78806 7.9207 9.38143 8.16691 10 8.16699L10.2305
      8.15527C10.7647 8.10227 11.2675 7.86632 11.6504 7.4834C12.0879 7.04583
      12.334 6.45177 12.334 5.83301L12.3223 5.60254C12.2692 5.0686 12.033 4.5664
      11.6504 4.18359C11.2675 3.80068 10.7647 3.56473 10.2305 3.51172L10
      3.5Z`} fill="#98A2B3"/>
  </svg>
);

export default PeopleBold;
